export type LocaleKey = 'ro' | 'en' | 'hu' | 'ua';

export type Locale = { id: LocaleKey; title: string };

export const locales: Locale[] = [
  { id: 'ro', title: 'Română' },
  { id: 'en', title: 'English' },
  { id: 'hu', title: 'Magyar' },
  { id: 'ua', title: 'українська мова' },
];

export const localeKeys = locales.map(({ id }) => id);

export const defaultLocaleKey: LocaleKey = 'ro';

export const LOCALE_COOKIE = 'LOCALE_KEY';
